@let compareTrayVisible = (showCompareTray$ | async) ?? false;

@if (showHeader$ | async) {
  <rma-site-header
    [basicHeader]="basicHeader$ | async"
    [fullWidthHeader]="fullWidthHeader$ | async"
    [showMarketingNav]="showMarketingNav$ | async"
    [renownedBranding]="renownedBranding$ | async"
    [loginHeader]="loginHeader$ | async"
  />
}
<section
  class="rma-content transition-[padding-bottom] duration-[240ms] ease-[cubic-bezier(0.4,0,1,1)] motion-reduce:transition-none [&.rma-compare-tray-space]:pb-[calc(var(--rma-compare-tray-height)_+_var(--rma-compare-tray-clearance))] [&.rma-compare-tray-space]:duration-[320ms] [&.rma-compare-tray-space]:ease-[cubic-bezier(0.16,1,0.3,1)]"
  [class.pt-0!]="(showHeader$ | async) === false"
  [class.scroll-smooth]="scrollSmooth"
  [class.renowned]="renownedBranding$ | async"
  [class.rma-compare-tray-space]="compareTrayVisible && hasTray()"
>
  <div class="rma-loader" [class.visible]="isLoading" [class.invisible]="!isLoading">
    @if (isLoading) {
      <mat-spinner />
    }
  </div>

  <router-outlet />

  <!-- Keep this block top-level: only an eagerly created view enables incremental hydration before bootstrap registers triggers.
       The layout watches the footer itself instead of using `hydrate on viewport`, because a route swap can paint one frame with the footer in view. -->
  @defer (hydrate when footerShouldHydrate()) {
    @if (showFooter$ | async) {
      <rma-footer class="nc-container" />
    }
  }
</section>

@if (compareTrayVisible) {
  <rma-compare-tray-container class="fixed inset-x-0 bottom-(--rma-compare-tray-clearance) z-40" (compare)="onCompare()" />
}
